import BlogPostCard from './BlogPostCard'

export default BlogPostCard
